// ColorPicker.tsx
import React from "react";

interface ColorPickerProps {
    label?: string;
    value: string;
    onChange: Function;
    id?: string;
}

export const InputColor = ({ label, value, onChange, id = "color-picker", }: ColorPickerProps) => (
    <>
        {label && (
            <label htmlFor={id} className="form-label">
                {label}
            </label>
        )}
        <input
            type="color"
            id={id}
            className="form-control form-control-color"
            title="Selecciona un color"
            value={value}
            onChange={(e) => onChange(e.target.value)}
        />
    </>
);
